import {
  ACTION_SUMMARY_DATA,
  HISTORY_TABLE_DATA,
  LOADER_STATUS,
  RECO_TABLE_DATA,
  SELECTED_HISTORY,
  SELECTED_RECO,
  SELECTED_ROW_RECO,
  UPLOAD_HISTORY_TOTAL_PAGES,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  recoTableData: [],
  historyTableData: [],
  selectedReco: [],
  selectedHistory: [],
  actionSummaryData:[],
  selectedRowReco:[],
  totalPagesHistory: 0,
};

/* eslint-disable default-case, no-param-reassign */
const imsRecoReconciliationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case RECO_TABLE_DATA:
      return {
        ...state,
        recoTableData: action.recoTableData,
      };
    case HISTORY_TABLE_DATA:
      return {
        ...state,
        historyTableData: action.historyTableData,
      };
    case SELECTED_RECO:
      return {
        ...state,
        selectedReco: action.selectedReco,
      };
      case SELECTED_ROW_RECO:
      return {
        ...state,
        selectedRowReco: action.selectedRowReco,
      };
    case SELECTED_HISTORY:
      return {
        ...state,
        selectedHistory: action.selectedHistory,
      };
       case ACTION_SUMMARY_DATA:
      return {
        ...state,
        actionSummaryData: action.actionSummaryData,
      };
       case UPLOAD_HISTORY_TOTAL_PAGES:
      return {
        ...state,
        totalPagesHistory: action.pages,
      };
    default:
      return state;
  }
};

export default imsRecoReconciliationReducer;
